import { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Slider from '@mui/material/Slider';
import { updateAssessmentScore } from '../../actions/sessions';

const RangeSlider = ({
  color,
  maxValue,
  minValue,
  assessment_id,
  value: valueProp,
  updateAssessmentScore,
}) => {
  const [value, setValue] = useState(valueProp);
  const [id] = useState(assessment_id);

  const onChange = (event, v) => {
    setValue(v);
    updateAssessmentScore({
      scores: { [id]: { value: v } },
    });
  };

  return (
    <div className={`input-range-${color}`}>
      <Slider
        max={maxValue}
        min={minValue}
        value={value}
        onChange={onChange}
        valueLabelDisplay="on"
        marks={[
          { value: minValue, label: minValue },
          { value: maxValue, label: maxValue },
        ]}
      />
    </div>
  );
};

RangeSlider.propTypes = {
  color: PropTypes.string.isRequired,
  maxValue: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired,
  assessment_id: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  updateAssessmentScore: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return { ...state };
}

export default connect(mapStateToProps, {
  updateAssessmentScore,
})(RangeSlider);
